import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Nacija } from './nacija';



@Component({
  selector: 'yt-nacija-modal-update',
  templateUrl: './nacija-modal-update.component.html'
})
export class NacijaModalUpdateComponent extends BaseModalUpdateComponent<Nacija> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Nacija>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
